module.exports = __webpack_public_path__ + "static/media/face-2.3d3a513a.jpg";